'use client';
import styles from './locations.module.scss';
import { MdArrowBackIos } from 'react-icons/md';
import { LocationType, PaginationType, ResponseType, ThemeEnum } from 'types';
import { COLORS } from 'utilities';
import { useContext, useEffect } from 'react';
import { GlobalContext } from 'context';
import { MobileHeaderComp } from 'components';
import { API, PATH } from 'data';
import { TbArrowRight } from 'react-icons/tb';
import { RestAPI, useRealTimeState, useThen } from 'scripts';
import { Button, Result, Spin } from 'antd';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

function PostFormCityComp() {
    const { theme } = useContext(GlobalContext);
    const [searchParams] = useSearchParams();
    const { category } = useParams();
    const nav = useNavigate();
    const locations = useRealTimeState<ResponseType<PaginationType<LocationType<'list'>>> | undefined>(undefined);

    const loadLocation = (goBack?: boolean) => {
        locations.set(undefined);
        const parent = searchParams.get('parent');
        const params: any = {
            page_size: 1000,
        };
        if (parent) params.parent = parent;
        else params.parent__isnull = 'true';
        RestAPI.get<PaginationType<LocationType<'list'>>>(API.location.list, params)
            .then((res) => {
                if (res.data.count === 0) {
                    if (goBack) nav(-1);
                    else nav(PATH.panel.addPost.main(category, parent ?? '').path);
                } else locations.set(res);
            })
            .catch(locations.set);
    };
    useThen(() => loadLocation(), [searchParams]);
    useEffect(() => loadLocation(true), []);

    const categoryCard = (title: string) => {
        return (
            <div className={`${styles['categories-card']} d-flex center-content-y justify-content-between pointer`}>
                <p className="t-400 t-p2 t-l-black1">{title}</p>
                <MdArrowBackIos size={16} color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray3} />
            </div>
        );
    };

    if (!locations.dep)
        return (
            <div className={`w-100 pv-9 center-content flex-1`}>
                <Spin size="small" />
            </div>
        );

    if (!locations.dep?.data)
        return (
            <Result
                status="error"
                title="خطا"
                subTitle="خطایی رخ داده است. لطفا کمی بعد مجددا تلاش نمایید"
                extra={[
                    <Button type="primary" key="console">
                        بازگشت
                    </Button>,
                    <Button key="buy">تلاش مجدد</Button>,
                ]}
            ></Result>
        );

    return (
        <>
            <MobileHeaderComp title={'انتخاب موقعیت مکانی آگهی جدید'} onIconClick={() => nav(-1)} />
            <div className="flex-column g-2">
                {searchParams.get('title')?.length ? (
                    <div
                        className={`${styles['categories-back']} d-flex center-content-y pointer`}
                        onClick={() => {
                            window.history.back();
                        }}
                    >
                        <TbArrowRight size={20} />
                        <p className="t-400 t-p2 t-l-black1">{searchParams.get('title')}</p>
                    </div>
                ) : null}
                {locations.dep.data.data
                    ?.sort((a, b) => a.title.localeCompare(b.title))
                    ?.map((location) => (
                        <div
                            key={location.id}
                            className={styles['categories-link']}
                            onClick={() => {
                                nav(
                                    PATH.panel.addPost.locations(category).path +
                                        '?parent=' +
                                        location.id +
                                        '&title=' +
                                        location.title,
                                );
                            }}
                        >
                            {categoryCard(location.title)}
                        </div>
                    ))}
            </div>
        </>
    );
}

export default PostFormCityComp;
